import { Box } from "@mui/material";

export default function ColorSwatch({
  color,
  size = 14,
}: { color?: string; size?: number }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: color ?? "grey.300",
        border: "1px solid",
        borderColor: "divider",
        flexShrink: 0,
      }}
    />
  );
}
